import React, {useState} from 'react'
import NavBar from './index'
import styled from 'styled-components'
import {injectIntl } from 'react-intl'
const initMobileMenuData = require('./tempData/mobileMenuData.json')


const Wrapper = styled.div`

`

const Icon = styled.div`
    padding-right:5px;
`

const Button = styled.button`
    padding: 5px 20px;

    transition: all 150ms ease;

    &:hover {
        color:${p=>p.theme.colors.info};
        border: 1px solid ${p=>p.theme.colors.info};
    }
`
const initialData = {
    theme: {
      bgColor: '',
      iconColor: '',
      navItemColor: '',
      subTextColor: '',
      hoverColor: '',
      subHeadingColor: '',
      linkColor: '',
      separatorColor: ''
    },
    content: [
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' }
    ]
  }

  
export default injectIntl((props) => {
    const [showBuilder, setShowBuilder] = useState(false)

    const { extra = {} } = props
    const { menuData = initialData, mobileMenuData = initMobileMenuData } = extra

    
    return (
        <Wrapper>
            <NavBar {...props}/>
        </Wrapper>
    )
})